import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import mobileLogo from '../assets/email-logo_white.png'

export class NavBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      backgroundImage: false
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const backgroundImage = window.scrollY < 1 ? false : true
      this.setState({ backgroundImage })
    })
  }

  render() {

    return (
      <Navbar expand='xs' fixed='top' className='logo-row'>
        <Row className={this.state.backgroundImage === false ? 'bg-row' : 'bg-row bg'}></Row>
        <Container>
          <Col xs={12} sm={6} className='logo-col'>
            <a href='https://meetglimpse.com/'>
              <img src={mobileLogo} className='top-logo' alt='glimpse' />
            </a>
          </Col>
          <Col>
            <a href="https://meetglimpse.com/#pricing">
              <div className='updated-div'>
                <span className='updated'>Get alerts</span>
              </div>
            </a>
          </Col>
        </Container>
      </Navbar>
    )
  }
}
